export const actionTypes = {
  updateImages: 'UPDATE_IMAGES',
  updateLogos: 'UPDATE_LOGOS',
  updateColors: 'UPDATE_COLORS',
  updateFonts: 'UPDATE_FONTS',
  updateTaglines: 'UPDATE_TAGLINES',
  updateBrandVoice: 'UPDATE_BRAND_VOICE',
  upDateBrandTones: 'UPDATE_BRAND_TONES',
  setData: 'SET_BRAND_KIT_DATA',
};

/* istanbul ignore next */
export function reducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.updateImages:
      return {
        ...state,
        images: payload,
      };
    case actionTypes.updateLogos:
      return {
        ...state,
        logos: payload,
      };
    case actionTypes.updateColors:
      return {
        ...state,
        colors: payload,
      };
    case actionTypes.updateFonts:
      return {
        ...state,
        fonts: payload,
      };
    case actionTypes.updateTaglines:
      return {
        ...state,
        taglines: payload,
      };
    case actionTypes.updateBrandVoice:
      return {
        ...state,
        brandVoice: payload,
      };
    case actionTypes.upDateBrandTones:
      return {
        ...state,
        brandTones: payload,
      };
    case actionTypes.setData:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
